import React from 'react';
import {withNavigationWatcher} from '../../../contexts/navigation';
import {Redirect} from 'react-router-dom';
import {
    ShippedDeliveryExceptionsPage,
    ShippedDeliveredPage,
    ShippedInTransitPage,
    ShippedRecentPage,
    ShippedVoidedPage
} from '../../../adminPages/Shipments/index';

const Home = () =>{
    return(<Redirect to="/admin/shipments/shipped-recents"/>);
}

const ShipmentsRoutes = [
    {
        path: '/admin/shipments',
        component: Home
    },
    {
        path: '/admin/shipments/shipped-recents',
        component: ShippedRecentPage
    },
    {
        path: '/admin/shipments/shipped-intransit',
        component: ShippedInTransitPage
    },
    {
        path: '/admin/shipments/shipped-delivered',
        component: ShippedDeliveredPage
    },
    {
        path: '/admin/shipments/shipped-delivery-exceptions',
        component: ShippedDeliveryExceptionsPage
    }, 
    {
        path: '/admin/shipments/shipped-voided',
        component: ShippedVoidedPage
    }
];

export default ShipmentsRoutes.map(route => {
    return {
        ...route,
        component: withNavigationWatcher(route.component)
    };
});
